// extracted by mini-css-extract-plugin
export default {"total":"style_total__zlQhl","total_media":"style_total_media__HYTI5","total_main":"style_total_main__e5q5b"};